import * as React from 'react';
import Typography from '../Typography';

export interface IBankCardProps {
    icon: React.ReactNode,
    type: string,
    interest_rate: number,
    total: string
}

export function BankCard({icon, type, interest_rate, total}: IBankCardProps) {
    return (
        <div className='flex flex-row justify-between items-center px-[10px] py-[20px] md:px-[20px] md:py-[32px] bg-white rounded-[10px]'>
            <div className='flex flex-col gap-[12px] md:gap-[20px] flex-1'>
                {icon}
                <Typography className=' text-[10px] md:text-[14px] font-normal'>
                    Строящееся жилье, {type}
                </Typography>
            </div>
            <div className='flex flex-col items-end gap-[12px] flex-1'>
                <Typography className='font-semibold text-[18px] md:text-[26px] md:font-bold lg:font-medium'>
                    {total}
                </Typography>
                <Typography className='font-normal text-[10px] md:text-[14px] text-black-50'>
                    Процентная ставка {interest_rate} %
                </Typography>
            </div>
        </div>
    );
}
